module.exports = __webpack_public_path__ + "img/slide-1.d3cf6a13.jpg";